var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconRoundText',[_c('MedalSVG',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n  No CyberClass "+_vm._s(_vm.user.created_at)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }